import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "./ShoppingDetail.module.css";
import { Api } from "../../../../uikit/service/api";
import cls from "classnames";
import useEnableScroll from "../../../../custom-hooks/useEnableScroll";
import { NO_WHEEL } from "../constants";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import useFeatureTags from "../../../../custom-hooks/useFeatureTags";

const ShoppingDetail = ({ onClick, shoppingInfo }) => {
  const api = new Api(false);

  const { enableScroll, mouseEnterLeave } = useEnableScroll();
  const feature_tags = useFeatureTags();
  const [buySuccessText, setBuySuccessText] = useState();
  const [buyButtonLoading, setBuyButtonLoading] = useState(false);
  const urlStr = `http://35.163.73.88:8010/remote/buyProductFromJingdong?product_name=${shoppingInfo.title}`;
  const url = `/be/svc-adapter/natural/proxy?url=${encodeURIComponent(urlStr)}`;

  const handleClick = () => {
    return;
    // setBuyButtonLoading(true);
    // api.get(url)
    //   .then((_) => {
    //     setBuyButtonLoading(false);
    //     message.success("Buy successfully");
    //     setBuySuccessText(
    //       "You order is being processed right now. Please add Natural to your Wechat for Beta users."
    //     );
    //   })
    //   .catch((error) => {
    //     setBuyButtonLoading(false);
    //     console.log(error);
    //     message.info("Buy failed");
    //   });
  };
  const noWheelClassName = enableScroll ? NO_WHEEL : "";

  const shoppingInfoClassName = cls(styles.shoppingInfo, noWheelClassName);

  return (
    <div
      className={styles.ShoppingDetail}
      onMouseEnter={() => mouseEnterLeave(true)}
      onMouseLeave={() => mouseEnterLeave(false)}
    >
      <div className={styles.inner}>
        <div className={styles.backNav}>
          <div onClick={onClick}>
            <img src={`${settings.S3CDN}${settings.viewAssetsPath}rightArrow.svg`} alt="" /> Go back
          </div>
        </div>
        <div className={shoppingInfoClassName}>
          <div className={styles.imgWrapper}>
            <img src={shoppingInfo.image} alt="" />
          </div>
          <div className={styles.desc}>{shoppingInfo.title}</div>
          <div className={styles.desc}>{buySuccessText}</div>
          {feature_tags.showBuyButton && (
            <div className={styles.buyNowButton} onClick={handleClick}>
              Buy now
              <Spin
                spinning={buyButtonLoading}
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 16,
                      marginLeft: "15px",
                      marginBottom: "5px",
                    }}
                    spin
                  />
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShoppingDetail;
